import common from '@/api/common'
import rules from "@/utils/formRules/rules";

export default {
  data() {
    return {
      // formRules: {
      //   phone: [{
      //     required: true,
      //     validator: (rule, value, callback) => {
      //       if (!rules.phone(value)) {
      //         callback(new Error('请输入正确的手机号'))
      //       } else {
      //         if (this.formRules.phonePass === value) {
      //           callback()
      //         } else {
      //           common.checkPhone(value, this.formRules.userUuid).then(res => {
      //             if (res) {
      //               this.formRules.phonePass = value
      //               callback()
      //             } else {
      //               callback(new Error('该手机号已经被注册'))
      //             }
      //           })
      //         }
      //       }
      //     },
      //     trigger: 'blur'
      //   }],
      //   idNumber: [{
      //     required: true,
      //     validator: (rule, value, callback) => {
      //       if (!rules.idNumber(value)) {
      //         callback(new Error('请输入正确的证件号码'))
      //       } else {
      //         // 避免验证所有表单时，重复请求
      //         if (this.formRules.idNumberPass === value) {
      //           callback()
      //         } else {
      //           common.checkIdNumber(value, this.formRules.userUuid).then(res => {
      //             if (res) {
      //               this.formRules.idNumberPass = value
      //               callback()
      //             } else {
      //               callback(new Error('该身份证号已经被注册'))
      //             }
      //           })
      //         }
      //       }
      //     },
      //     trigger: 'blur'
      //   }],
      //   idName: [{ required: true,
      //     validator: (rule, value, callback) => {
      //       if (value) {
      //         callback()
      //       } else {
      //         callback(new Error('请输入球员姓名'))
      //       }
      //     },
      //     trigger: 'blur' }],
      //   gender: [{ required: true,
      //     validator: (rule, value, callback) => {
      //       if (value) {
      //         callback()
      //       } else {
      //         callback(new Error('请选择性别'))
      //       }
      //     },
      //     trigger: 'change' }],
      //   playerNumber: [{ required: false,
      //     validator: (rule, value, callback) => {
      //       if (!value) {
      //         callback()
      //       } else {
      //         if (rules.playerNumber(value)) {
      //           callback()
      //         } else {
      //           callback(new Error('请输入0-99内的球衣号码'))
      //         }
      //       }
      //     },
      //     trigger: 'blur' }],
      //   position: [{ required: true,
      //     validator: (rule, value, callback) => {
      //       if (value.length) {
      //         callback()
      //       } else {
      //         callback(new Error('请选择球员位置'))
      //       }
      //     },
      //     trigger: 'change' }],
      //   squadUuid: [{ required: false,
      //     validator: (rule, value, callback) => {
      //       callback()
      //       // if (value) {
      //       //   callback()
      //       // } else {
      //       //   callback(new Error('请选择球队'))
      //       // }
      //     },
      //     trigger: 'change' }],
      //   youthUuid: [{ required: true, message: '请选择单位', trigger: 'change' }],
      //   unit: [{ required: true,
      //     validator: (rule, value, callback) => {
      //       if (value) {
      //         callback()
      //       } else {
      //         callback(new Error('请输入单位名称'))
      //       }
      //     },
      //     trigger: 'blur' }],
      //   organUuid: [{ required: true, message: '请选择管理单位', trigger: 'change' }],
      //   idNumberPass: '',
      //   phonePass: ''
      // },

      validate_idnumber: '',
      validate_phone: '',
      validate_user_uuid: '',
    }
  },

  computed: {
    formRules() {
      const that = this;
      return {
        idType: [ //  证件类型
          { required: true, message: '请选择证件类型', trigger: 'change' }
        ],
        idCountry: [ //  颁发国家/地区
          { required: true, message: '请选择证件类型', trigger: ['change', 'blur'] }
        ],
        idNumber: [{
          required: true,
          validator: async (rule, value, callback) => {
            const { idType } = that.playerInfo;
            console.log('idType', idType)
            console.log('value', value)
            console.log('validate_user_uuid', that.validate_user_uuid)
            if (!idType) {
              callback();
            } else {
              let validateFunc = null;
              let errorTips = '';
              switch (idType) {
                case 'IDNUMBER': // 中国居民身份证
                  validateFunc = rules.idNumber;
                  errorTips = '该身份证号已经被注册';
                  break;
                case 'IDTYPECODEWGJZZ': //  外国人永久居留身份证
                  validateFunc = rules.checkWork;
                  errorTips = '请输入有效的外国人居留证号码';
                  break;
                case 'IDTYPECODEHMT': //  港澳台居民居住证
                  validateFunc = rules.idNumber;  ///^8[1-3]\d{16}/
                  errorTips = '请输入18位有效的港澳台居民居住证号码';
                  break;
                case 'HM': //  港澳居民来往内地通行证
                  validateFunc = rules.checkHkongMacao;
                  errorTips = '请输入9位有效的港澳居民来往内地通行证号码';
                  break;
                case 'TAI': //  台湾居民来往大陆通行证
                  validateFunc = rules.checkTaiwOld;
                  errorTips = '请输入8位有效的台湾居民来往大陆通行证号码';
                  break;
                case 'PASSPORT': //  护照（仅国外教练员使用）
                  validateFunc = rules.checkPassport;
                  errorTips = '请输入有效的护照号码';
                  break;
              }
              if (value) {
                if (validateFunc(value)) {
                  if (value === that.validate_idnumber) {
                    callback()
                  } else {
                    try {
                      const res = common.checkIdNumber(value, that.validate_user_uuid || undefined)
                      if (res) {
                        callback()
                      } else {
                        callback(new Error(errorTips))
                      }
                    } catch (err) {
                      callback()
                      console.error('err', err)
                    }
                  }
                } else {
                  calllback(new Error(errorTips))
                }
              } else {
                callback(new Error('请填写有效证件号'))
              }

            }
          },
          trigger: 'blur'
        }],
        // phone: [{
        //   required: true,
        //   validator: (rule, value, callback) => {
        //     if (!rules.phone(value)) {
        //       callback(new Error('请输入正确的手机号'))
        //     } else {
        //       if (this.formRules.phonePass === value) {
        //         callback()
        //       } else {
        //         common.checkPhone(value, this.formRules.userUuid).then(res => {
        //           if (res) {
        //             this.formRules.phonePass = value
        //             callback()
        //           } else {
        //             callback(new Error('该手机号已经被注册'))
        //           }
        //         })
        //       }
        //     }
        //   },
        //   trigger: 'blur'
        // }],
        idName: [{
          required: true,
          validator: (rule, value, callback) => {
            if (value) {
              callback()
            } else {
              callback(new Error('请输入球员姓名'))
            }
          },
          trigger: 'blur'
        }],
        birthday: [{
          required: true,
          validator: (rule, value, callback) => {
            if (value) {
              callback()
            } else {
              callback(new Error('请选择出生年月'))
            }
          },
          trigger: 'change'
        }],
        gender: [{
          required: true,
          validator: (rule, value, callback) => {
            if (value) {
              callback()
            } else {
              callback(new Error('请选择性别'))
            }
          },
          trigger: 'change'
        }],
        playerNumber: [{
          required: false,
          validator: (rule, value, callback) => {
            if (!value) {
              callback()
            } else {
              if (rules.playerNumber(value)) {
                callback()
              } else {
                callback(new Error('请输入0-99内的球衣号码'))
              }
            }
          },
          trigger: 'blur'
        }],
        position: [{
          required: true,
          validator: (rule, value, callback) => {
            if (value.length) {
              callback()
            } else {
              callback(new Error('请选择球员位置'))
            }
          },
          trigger: 'change'
        }],
        squadUuid: [{
          required: false,
          validator: (rule, value, callback) => {
            callback()
            // if (value) {
            //   callback()
            // } else {
            //   callback(new Error('请选择球队'))
            // }
          },
          trigger: 'change'
        }],
        youthUuid: [{ required: true, message: '请选择单位', trigger: 'change' }],
        unit: [{
          required: true,
          validator: (rule, value, callback) => {
            if (value) {
              callback()
            } else {
              callback(new Error('请输入单位名称'))
            }
          },
          trigger: 'blur'
        }],
        organUuid: [{ required: true, message: '请选择管理单位', trigger: 'change' }],
      }
    }
  }
}
